import React from "react"
import PropTypes from "prop-types"

import { 
  Grid, Col, PageHeader, Well, Glyphicon,
  Form, FormGroup, ControlLabel, FormControl, Button
} from "react-bootstrap"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
// import { LinkContainer } from "react-router-bootstrap"

import { Map, fromJS } from "immutable"
import bcrypt from "bcryptjs"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"

const newUser = fromJS({
  username: "",
  email: "",
  loginTime: "",
  loginIp: "",
  password_new: "",
  password_confirmation: "",
  status: ""
})

class User extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    edited: Map()
  }

  handleSubmit = e => {
    e.preventDefault()

    let user = this.state.edited
    let errors = ""
    
    if (this.props.username === "new") {      // new user      
      
      // Check mandatory fields
      if (!user.get("username")) {
        errors += (errors.length > 0 ? "\n" : "") + "Username is required!"
      }
      if (!user.get("email")) {
        errors += (errors.length > 0 ? "\n" : "") + "Email is required!"
      }
      if (!user.get("password_new")) {
        errors += (errors.length > 0 ? "\n" : "") + "Password is required!"
      } else if (user.get("password_new") !== user.get("password_confirm")) {
        errors += (errors.length > 0 ? "\n" : "") + "New Password does not match with Confirmation Password!"
      }

      if (errors) {
        alert(errors)
        return
      } else {
        user = user.set("password", bcrypt.hashSync(user.get("password_new"), 10))
        user = user.delete("password_new")
        user = user.delete("password_confirm")
        this.props.actions.createUser(user)
      }

    } else {                                  // existing user
      
      // changed password
      if (user.get("password_new")) {
        if (!bcrypt.compareSync(user.get("password_old"), this.props.user.get("password")))
          errors += (errors.length > 0 ? "\n" : "") + "Wrong Password!"
        if (user.get("password_new") !== user.get("password_confirm"))
          errors += (errors.length > 0 ? "\n" : "") + "New Password does not match with Confirmation Password!"
        if (bcrypt.compareSync(user.get(""), this.props.user.get("password")))
          errors += (errors.length > 0 ? "\n" : "") + "New Password equals with previous password!"
      }

      if (errors) {
        alert(errors)
        return
      } else {
        user = user.set("password", bcrypt.hashSync(user.get("password_new"), 10))
        user = user.delete("password_old")
        user = user.delete("password_new")
        user = user.delete("password_confirm")
        this.props.actions.updateUser(this.props.username, user)
      }
    }

    // Reset edited state
    this.setState({ edited: Map() })
    this.props.history.push("/users")
  }

  handleChange = e => {
    const { name, value } = e.target
    this.setState((prev, props) => ({
      edited: prev.edited.set(name, value)
    }))
  }

  handleCancel = e => {
    if (this.state.edited.size === 0 || window.confirm("Are you sure you want to cancel?")) {
      this.props.history.push("/users")
    }
  }

  getValue = (name, isDate = false) => {
    // let value = this.state.edited.get(name) || this.props.user.get(name) || ""
    // return (
    //   isDate ? (value ? moment(value).tz(defaultTimezone).format() : moment().tz(defaultTimezone).format()) : value
    // )
    return this.state.edited.get(name) || this.props.user.get(name) || ""
  }

  render() {
    return (
      <Grid>
        <PageHeader>User {this.getValue("username")}</PageHeader>

        <Form horizontal onSubmit={this.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Username</Col>
            <Col sm={10}>
              <FormControl
                name="username"
                placeholder="Username"
                value={this.getValue("username")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Email</Col>
            <Col sm={10}>
              <FormControl
                type="email"
                name="email"
                placeholder="Email"
                value={this.getValue("email")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Last Login</Col>
            <Col sm={10}>
              <FormControl.Static>
                {this.getValue("loginTime") ? moment(this.getValue("loginTime")).format("LLL") : ""}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Login IP</Col>
            <Col sm={10}>
              <FormControl.Static>{this.getValue("loginIp")}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Access</Col>
            <Col sm={10}>
              <FormControl.Static>{this.getValue("access")}</FormControl.Static>
            </Col>
          </FormGroup>
          {
            this.props.username !== "new" ?
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>Current Password</Col>
              <Col sm={10}>
                <FormControl
                  type="password"
                  name="password_old"
                  placeholder="Current Password"
                  value={this.getValue("password_old")}
                  onChange={this.handleChange} />
              </Col>
            </FormGroup>
            : null
          }
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>New Password</Col>
            <Col sm={10}>
              <FormControl
                type="password"
                name="password_new"
                placeholder="New Password"
                value={this.getValue("password_new")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Confirm Password</Col>
            <Col sm={10}>
              <FormControl
                type="password"
                name="password_confirm"
                placeholder="Confirm Password"
                value={this.getValue("password_confirm")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Status</Col>
            <Col sm={10}>
              <FormControl.Static>{this.getValue("status")}</FormControl.Static>
            </Col>
          </FormGroup>
        </Form>
          
        <Well bsSize="small">
          <Button bsSize="small" bsStyle="danger" onClick={this.handleCancel}>
            <Glyphicon glyph="remove" /> Cancel
          </Button>
          <Button className="pull-right" bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
            <Glyphicon glyph="save" /> Save
          </Button>
        </Well>
      </Grid>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  username: ownProps.match.params.id,
  user: state.getIn(["users", ownProps.match.params.id]) || newUser
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(User))



// WEBPACK FOOTER //
// ./src/components/User.js